import React, { Component } from 'react';
import ShootTypeComponent from '../../Components/Book/Shoots/Shoots';
import defaultShoots from '../../Constants/shoots';

export default class ShootType extends Component {
	render(): React.ReactElement {
		return (
			<ShootTypeComponent shoots={defaultShoots} />
		);
	}
}
